import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f05e33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  slot: "content",
  class: "ion-padding item-lines-full"
}
const _hoisted_4 = { class: "item-actions" }


import { IonAccordion, IonButton, IonChip, IonIcon, IonItem, IonLabel, modalController } from '@ionic/vue'
import { createOutline } from 'ionicons/icons'
import ContentBlocks from '@/components/ContentBlocks.vue'
import TextFormatter from '@/components/TextFormatter.vue'

import { EventScheduleItem, useEventStore } from '@/store/event'
import { useAuthStore } from '@/store/auth'
import { format } from '@/lib/date-fns-local'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleItem',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: EventScheduleItem
}



const eventPlaces = useEventStore().event.places
const isAdmin = useAuthStore().claims.isAdmin

async function editItem () {
  const ScheduleItemForm = await import('@/components/ScheduleItemForm.vue')
  return (await modalController.create({
    component: ScheduleItemForm.default,
    componentProps: { itemId: props.item.__id },
    ...ScheduleItemForm.modalOptions
  })).present()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonAccordion), {
    "data-id": __props.item.__id
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonItem), { slot: "header" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.item.time.originalStart)
              ? (_openBlock(), _createElementBlock("s", _hoisted_2, _toDisplayString(_unref(format)(__props.item.time.originalStart, 'HH:mm')), 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref(format)(__props.item.time.start, 'HH:mm')), 1)
          ]),
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.item.title) + " ", 1),
              (__props.item.place)
                ? (_openBlock(), _createBlock(_unref(IonChip), {
                    key: 0,
                    outline: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(eventPlaces)[__props.item.place].label), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(isAdmin))
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                fill: "clear",
                size: "small",
                onClick: editItem
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(createOutline)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TextFormatter, {
          value: __props.item.description
        }, null, 8, ["value"]),
        _createVNode(ContentBlocks, {
          value: __props.item.blocks
        }, null, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["data-id"]))
}
}

})